import Chip from './Chip';
import { ChipProps, ChipValueProps } from './types';

export type { ChipProps, ChipValueProps };
export default Chip;
